import { createI18n } from 'vue-i18n';
import en from '@/lang/en';
import fr from '@/lang/fr';

const DEFAULT_LOCALE = 'fr';
export const messages = {
    en,
    fr
};

export const availableLocales = [
    { label: 'Français', flag: '🇫🇷', value: 'fr' },
    { label: 'English', flag: '🇺🇸', value: 'en' }
];

export function getCurrentLocale(): 'fr' | 'en' {
    return (navigator.language || DEFAULT_LOCALE).indexOf('en') === 0 ? 'en' : 'fr';
}

const i18n = createI18n({
    legacy: false,
    locale: (navigator.language || DEFAULT_LOCALE).indexOf('en') === 0 ? 'en' : 'fr',
    fallbackLocale: DEFAULT_LOCALE,
    availableLocales: ['fr', 'en'],
    messages
});

export async function fetchAndMergeTranslations(url: string) {
    try {
        if (!url) {
            return;
        }
        const response = await fetch(url);

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const fetchedTranslations = await response.json();
        const english = fetchedTranslations.en;
        const french = fetchedTranslations.fr;

        if (english) {
            Object.assign(messages.en, english);
            i18n.global.setLocaleMessage('en', messages.en);
        }
        if (french) {
            Object.assign(messages.fr, french);
            i18n.global.setLocaleMessage('fr', messages.fr);
        }
    } catch (error) {
        console.error('Error fetching translations:', error);
    }
}

export default i18n;
